export default "__VITE_ASSET__6dRCdH4m__"